export const WHITE_LABEL_BRANDS = Object.freeze([
  {
    domain: 'ugc.invest-btv.com',
    title: 'BTV',
    description: 'Submit your response to BTV.',
    hideVideoPeelLogoOnThankYouPage: true,
    faviconUrl: '/white-label/btv-favicon.svg',
  },
]);

const getCurrentHost = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.location.host;
};

export const getWhiteLabelBrandByHost = (host = getCurrentHost()) =>
  WHITE_LABEL_BRANDS.find((brand) => brand.domain === host) || null;

export const getWhiteLabelBrandByDomain = (domain) =>
  WHITE_LABEL_BRANDS.find((brand) => brand.domain === domain) || null;



// WEBPACK FOOTER //
// ./src/constants/white-label-brands.js